<template>
    <div class="title-list-container">
        <!-- 搜索区域 -->
        <div class="search-bar">
            <el-input v-model="searchForm.title" placeholder="请输入描述" clearable size="large"
                style="width: 300px; margin-right: 15px" @keyup.enter="handleSearch">
                <template #prefix>
                    <el-icon>
                        <Search />
                    </el-icon>
                </template>
            </el-input>

            <el-button type="primary" size="large" @click="handleSearch">
                <el-icon>
                    <Search />
                </el-icon>
                搜索
            </el-button>

            <el-button type="success" size="large" @click="openAddDialog" style="float: right">
                <el-icon>
                    <Plus />
                </el-icon>
                新增描述
            </el-button>

            <el-button type="warning" size="large" @click="openBatchImportDialog"
                style="margin-left: 10px; float: right">
                <el-icon>
                    <Upload />
                </el-icon>
                批量导入
            </el-button>
        </div>

        <!-- 描述列表 -->
        <el-table :data="recordList" stripe style="width: 100%; margin-top: 20px" v-loading="loading">
            <el-table-column prop="title" label="描述" width="300" />
            <el-table-column prop="use_num" label="使用次数" width="120" />
            <el-table-column prop="prohibited_words" label="违禁词" width="150" />
            <el-table-column prop="status" label="状态" width="120">
                <template #default="{ row }">
                    <el-tag :type="row.status === 2 ? 'success' : 'warning'">
                        {{ row.status === 2 ? '正常' : '待审核' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="180" />

            <el-table-column label="操作" width="250" fixed="right">
                <template #default="scope">
                    <el-button type="primary" size="small" @click="openEditDialog(scope.row)">
                        <el-icon>
                            <Edit />
                        </el-icon>
                        编辑
                    </el-button>
                    <el-button type="danger" size="small" @click="handleDelete(scope.row.id)">
                        <el-icon>
                            <Delete />
                        </el-icon>
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-container">
            <el-pagination v-model:current-page="pagination.page" v-model:page-size="pagination.pageSize"
                :total="pagination.total" :page-sizes="[10, 20, 30, 50]"
                layout="total, sizes, prev, pager, next, jumper" @size-change="fetchRecordList"
                @current-change="fetchRecordList" />
        </div>

        <!-- 在对话框后面添加批量导入对话框 -->
        <el-dialog v-model="importDialogVisible" title="批量导入描述" width="500px" :close-on-click-modal="false"
            @close="resetImportDialog">
            <el-tabs v-model="importActiveTab">
                <el-tab-pane label="Excel导入" name="excel">
                    <el-upload class="upload-demo" drag ref="excelUploadRef" action="" :auto-upload="false"
                        :on-change="handleExcelChange" accept=".xlsx,.xls" :limit="1">
                        <el-icon class="el-icon--upload"><upload-filled /></el-icon>
                        <div class="el-upload__text">将Excel文件拖到此处，或<em>点击上传</em></div>
                        <template #tip>
                            <div class="el-upload__tip">请上传Excel文件，支持.xlsx和.xls格式</div>
                            <div style="margin-top: 20px; text-align: center;">
                                <el-button type="text" @click="downloadTemplate">
                                    <el-icon>
                                        <Download />
                                    </el-icon>
                                    下载Excel模板
                                </el-button>
                            </div>
                        </template>
                    </el-upload>
                </el-tab-pane>
                <el-tab-pane label="TXT导入" name="txt">
                    <el-upload class="upload-demo" drag ref="txtUploadRef" action="" :auto-upload="false"
                        :on-change="handleTxtChange" accept=".txt" :limit="1">
                        <el-icon class="el-icon--upload"><upload-filled /></el-icon>
                        <div class="el-upload__text">将TXT文件拖到此处，或<em>点击上传</em></div>
                        <template #tip>
                            <div class="el-upload__tip">
                                <p>请上传TXT文件，每行一个描述</p>
                                <!-- <p>格式：全导入：描述内容|违禁词(可选)|使用次数(可选)|状态(可选)</p> -->
                                <p>格式：描述内容,一行一个！</p>
                            </div>
                        </template>
                    </el-upload>
                </el-tab-pane>
            </el-tabs>

            <template #footer>
                <el-button @click="importDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitBatchImport">确认导入</el-button>
            </template>
        </el-dialog>

        <!-- 新增/编辑对话框 -->
        <el-dialog v-model="dialogVisible" :title="dialogTitle" width="600px" :close-on-click-modal="false">
            <el-form ref="recordForm" :model="recordForm" label-width="120px" :rules="formRules">
                <el-form-item label="描述" prop="title">
                    <el-input v-model="recordForm.title" placeholder="请输入描述" size="large" />
                </el-form-item>

                <el-form-item label="违禁词">
                    <el-input v-model="recordForm.prohibited_words" placeholder="请输入违禁词，多个用逗号分隔" size="large" />
                </el-form-item>

                <el-form-item label="状态" prop="status">
                    <el-radio-group v-model="recordForm.status">
                        <el-radio :label="1">待审核</el-radio>
                        <el-radio :label="2">正常</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="使用次数">
                    <el-input-number v-model="recordForm.use_num" :min="0" size="large" />
                </el-form-item>
            </el-form>

            <template #footer>
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitRecordForm">确认</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios';
import config from '@/config.js';
import {
    Search, Plus, Edit, Delete, UploadFilled, Download
} from '@element-plus/icons-vue'
import * as XLSX from 'xlsx'
export default {

    components: {
        Search, Plus, Edit, Delete, UploadFilled, Download
    },
    props: {
        titleId: {
            type: Number,
            required: true
        },
        storeId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            loading: false,
            dialogVisible: false,
            dialogTitle: '新增描述',
            isEditMode: false,
            importDialogVisible: false,
            importActiveTab: 'excel',
            importFile: null,
            importData: [],
            searchForm: {
                title: ''
            },

            recordForm: {
                id: null,
                title: '',
                prohibited_words: '',
                status: 2,
                use_num: 0,
                desc_id: this.titleId,
                store_id: this.storeId
            },
            formRules: {
                title: [
                    { required: true, message: '请输入描述', trigger: 'blur' }
                ],
                status: [
                    { required: true, message: '请选择状态', trigger: 'change' }
                ]
            },
            recordList: [],
            pagination: {
                page: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    mounted() {
        this.fetchRecordList();
    },
    methods: {
        // 下载Excel模板
        downloadTemplate() {
            // 创建工作簿
            const wb = XLSX.utils.book_new()

            // 创建数据
            const templateData = [
                {
                    '描述': '示例描述1'
                },
                {
                    '描述': '示例描述2'
                }
            ]

            // 创建工作表
            const ws = XLSX.utils.json_to_sheet(templateData)

            // 设置列宽
            ws['!cols'] = [
                { wch: 30 },  // 描述列宽
            ]

            // 添加工作表到工作簿
            XLSX.utils.book_append_sheet(wb, ws, "描述数据")

            // 生成Excel文件并下载
            XLSX.writeFile(wb, '描述批量导入模板.xlsx')
        },
        // 打开新增对话框
        openAddDialog() {
            this.dialogTitle = '新增描述';
            this.isEditMode = false;
            this.recordForm = {
                id: null,
                title: '',
                prohibited_words: '',
                status: 2,
                use_num: 0,
                desc_id: this.titleId,
                store_id: this.storeId
            };
            this.dialogVisible = true;
        },

        // 打开编辑对话框
        openEditDialog(row) {
            this.dialogTitle = '编辑描述';
            this.isEditMode = true;
            this.recordForm = {
                id: row.id,
                title: row.title,
                prohibited_words: row.prohibited_words,
                status: row.status,
                use_num: row.use_num,
                desc_id: this.titleId,
                store_id: this.storeId
            };
            this.dialogVisible = true;
        },

        // 新增重置导入弹窗状态的方法
        resetImportDialog() {
            // 清空上传组件
            if (this.$refs.excelUploadRef) {
                this.$refs.excelUploadRef.clearFiles();
            }
            if (this.$refs.txtUploadRef) {
                this.$refs.txtUploadRef.clearFiles();
            }

            // 重置上传数据
            this.importFile = null;
            this.importData = [];

            // 重置标签页到Excel导入（可选）
            this.importActiveTab = 'excel';
        },
        openBatchImportDialog() {
            this.resetImportDialog();  // 打开时也重置状态
            this.importDialogVisible = true
            this.importActiveTab = 'excel'
            this.importFile = null
            this.importData = []
        },

        handleExcelChange(file) {
            this.importFile = file
            const reader = new FileReader()
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result)
                const workbook = XLSX.read(data, { type: 'array' })
                const firstSheet = workbook.Sheets[workbook.SheetNames[0]]
                const jsonData = XLSX.utils.sheet_to_json(firstSheet)

                this.importData = jsonData.map(item => ({
                    title: item.title || item['描述'] || '',
                    prohibited_words: item.prohibited_words || item['违禁词'] || '',
                    use_num: item.use_num || item['使用次数'] || 0,
                    status: item.status || item['状态'] || 2
                }))
            }
            reader.readAsArrayBuffer(file.raw)
        },

        handleTxtChange(file) {
            this.importFile = file
            const reader = new FileReader()
            reader.onload = (e) => {
                const content = e.target.result
                const lines = content.split('\n')

                this.importData = lines.map(line => {
                    if (!line.trim()) return null

                    const parts = line.split('|').map(p => p.trim())
                    return {
                        title: parts[0] || '',
                        prohibited_words: parts[1] || '',
                        use_num: parseInt(parts[2]) || 0,
                        status: parseInt(parts[3]) || 2
                    }
                }).filter(item => item && item.title)
            }
            reader.readAsText(file.raw)
        },

        async submitBatchImport() {
            if (this.importData.length === 0) {
                this.$message.warning('没有可导入的数据')
                return
            }

            try {
                const { data } = await axios.post(
                    `${config.BASE_URL}/shop/api/desc_create_record.php`,
                    {
                        action: 'batch_import',
                        store_id: this.storeId,
                        desc_id: this.titleId,
                        batch: this.importData
                    }
                )

                if (data.success) {
                    this.$message.success(`成功导入 ${data.imported_count} 条记录`)
                    this.resetImportDialog();  // 导入成功后重置弹窗

                    this.importDialogVisible = false
                    this.fetchRecordList()
                } else {
                    this.$message.error(data.error || '导入失败')
                }
            } catch (error) {
                this.$message.error('导入失败: ' + (error.response?.data?.error || error.message))
                console.error('导入错误:', error)
            }
        },
        // 提交表单（新增/编辑）
        submitRecordForm() {
            this.$refs.recordForm.validate(async (valid) => {
                if (valid) {
                    try {
                        const action = this.isEditMode ? 'update' : 'add';
                        const { data } = await axios.post(
                            `${config.BASE_URL}/shop/api/desc_create_record.php`,
                            {
                                action,
                                ...this.recordForm
                            }
                        );

                        if (data.success) {
                            this.$message.success(this.isEditMode ? '更新成功' : '添加成功');
                            this.dialogVisible = false;
                            this.fetchRecordList();
                        } else {
                            this.$message.error(data.error || '操作失败');
                        }
                    } catch (error) {
                        const errorMsg = error.response?.data?.error || error.message || '操作失败';
                        this.$message.error(`操作失败: ${errorMsg}`);
                        console.error('表单提交错误:', error);
                    }
                }
            });
        },
        async fetchRecordList() {
            this.loading = true;
            try {
                const params = {
                    action: this.searchForm.title ? 'search' : 'list',
                    store_id: this.storeId,
                    desc_id: this.titleId,
                    page: this.pagination.page,
                    page_size: this.pagination.pageSize
                };

                if (this.searchForm.title) {
                    params.title = this.searchForm.title;
                }

                const { data } = await axios.post(
                    `${config.BASE_URL}/shop/api/desc_create_record.php`,
                    params
                );

                if (data.data) {
                    this.recordList = data.data;
                    this.pagination.total = data.pagination?.total || data.data.length;
                }
            } catch (error) {
                this.$message.error('获取描述列表失败');
                console.error('获取描述列表错误:', error);
            } finally {
                this.loading = false;
            }
        },

        handleSearch() {
            this.pagination.page = 1;
            this.fetchRecordList();
        },

        async handleDelete(id) {
            this.$confirm('确定要删除该描述吗？', '警告', {
                confirmButtonText: '确认删除',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const { data } = await axios.post(
                        `${config.BASE_URL}/shop/api/desc_create_record.php`,
                        {
                            action: 'delete',
                            id: id,
                            store_id: this.storeId
                        }
                    );

                    if (data.success) {
                        this.$message.success('删除成功');
                        this.fetchRecordList();
                    } else {
                        this.$message.error(data.error || '删除失败');
                    }
                } catch (error) {
                    this.$message.error('删除失败');
                    console.error('删除错误:', error);
                }
            }).catch(() => { });
        }
    }
}
</script>

<style>
.title-list-container {
    padding: 20px;

    .search-bar {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        padding: 16px;
        background: #f8fafc;
        border-radius: 8px;
    }

    .pagination-container {
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;
    }

    /* 操作按钮样式 */
    .el-button {
        display: inline-flex;
        align-items: center;

        .el-icon {
            margin-right: 5px;
        }
    }
}
</style>